import React, { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import ReportGridPage from "../components/ReportGridPage";
import { cypDHIS2SRHHeader } from "../components/HeaderAttribute";
import jsPDF from "jspdf";
import "jspdf-autotable";
import fpaiLogo from "../image/FPAILogo.jpg";
import MultiSelect from "../ReusableComponents/MultiSelect";
// import * as XLSX from "sheetjs-style";
import * as XLSX from "xlsx-js-style";
import { useUserCapability } from "../components/ConstantReducerProvider";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import Loader from "../ReusableComponents/Loader";

const CYPDHIS2SRH = () => {
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const [branchProject, setBranchProject] = useState("");
  const [branchName, setBranchName] = useState("");
  const [sdp, setSDP] = useState("");
  const [branchProjectError, setBranchProjectError] = useState("");
  const [sdpError, setSDPError] = useState("");
  const [area, setArea] = useState("");
  const [areaError, setAreaError] = useState("");
  const [bindBranchProjectDD, setBindBranchProjectDD] = useState([]);
  const [bindCYPDHIS2SRHData, setBindCYPDHIS2SRHData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [fromDateError, setFromDateError] = useState("");
  const [toDate, setToDate] = useState("");
  const [getSDPDatas, setGetSDPDatas] = useState([]);
  const [bindSDP, setBindSDP] = useState([]);
  const [bindMonthDD, setBindMonthDD] = useState([]);
  const [year, setYear] = useState("");
  const [yearError, setYearError] = useState("");
  const [bindYearDD, setBindYearDD] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [getAreaDatas, setGetAreaDatas] = useState([]);
  const [bindArea, setBindAreaDD] = useState([]);

  const [branchProjectNamesList, setBranchProjectNamesList] = useState([]);
  const [sdpNamesList, setSDPNamesList] = useState([]);
  const [areaNamesList, setAreaNamesList] = useState([]);

  useEffect(() => {
    if (branchProject) {
      try {
        const getSelectedSDP = async () => {
          const userProfileDatas = userProfileState.userProfile;
          const [profile] = userProfileDatas;
          const data = {
            mstOrganizationStructureId: profile.MstOrganizationId,
            mstBranchId: profile.MstLocationId,
            mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
            mstUserId: profile.MstUserId,
            mstRoleId: profile.MstRoleId,
            languageCode: "en",
          };
          const locationResponse = await BindPostAPI([data], "SDPAPI/GetSDP");
          setGetSDPDatas(locationResponse.data.Table);

          if (userProfileDatas && userProfileDatas[0]) {
            const sdpLabels = locationResponse.data.Table.filter((item) =>
              branchProject.includes(parseInt(item.MstLocationId))
            ).map((item) => ({
              MstSDPId: item.MstSDPId,
              SDP_en: item.SDP_en,
            }));

            const sdpSelected = sdpLabels.map((SD) => ({
              value: SD.MstSDPId,
              label: SD.SDP_en,
            }));

            if (
              userProfileDatas[0].MstOrganizationId == 1 ||
              userProfileDatas[0].MstOrganizationId == 2
            ) {
              setBindSDP(sdpSelected);
            } else {
              const allSDPIds = userProfileDatas[0]?.AllSDP;

              if (allSDPIds && Array.isArray(allSDPIds)) {
                const filteredSdpSelected = sdpSelected.filter((sdp) =>
                  allSDPIds.includes(sdp.value)
                );
                setBindSDP(filteredSdpSelected);
              }
              const sdpId = userProfileDatas[0]?.MstSDPId;
              if (sdpId) {
                const filteredSdpSelected = sdpSelected.filter((sdp) =>
                  Array.isArray(sdpId)
                    ? sdpId.includes(sdp.value)
                    : sdpId === sdp.value
                );

                setBindSDP(filteredSdpSelected);
              }
            }
          }
        };

        getSelectedSDP();
      } catch (e) {
        console.log(`error fetch data ${e}`);
      }
    }
  }, [
    branchProject ? branchProject : undefined,
    userProfileDatas ? userProfileDatas : undefined,
  ]);
  useEffect(() => {
    if (sdp) {
      try {
        const getSelectedArea = async () => {
          const userProfileDatas = userProfileState.userProfile;
          const [profile] = userProfileDatas;
          const data = {
            mstOrganizationStructureId: profile.MstOrganizationId,
            mstBranchId: profile.MstLocationId,
            mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
            mstUserId: profile.MstUserId,
            mstRoleId: profile.MstRoleId,
            languageCode: "en",
          };
          const locationResponse = await BindPostAPI([data], "AreaAPI/GetArea");
          setGetAreaDatas(locationResponse.data.Table);

          const areaLabels = locationResponse.data.Table.filter((item) =>
            sdp.includes(item.MstSDPId)
          ).map((item) => ({
            MstAreaId: item.MstAreaId,
            AreaName_en: item.AreaName_en,
          }));

          const areaSelected = areaLabels.map((AR) => ({
            value: AR.MstAreaId,
            label: AR.AreaName_en,
          }));

          setBindAreaDD(areaSelected);
        };

        getSelectedArea();
      } catch (e) {
        console.log(`error fetch data ${e}`);
      }
    }
  }, [sdp ? sdp : undefined]);

  useEffect(() => {
    if (
      userProfileDatas[0]?.MstOrganizationId == 2 ||
      userProfileDatas[0]?.MstOrganizationId == 3
    ) {
      if (userProfileDatas[0]?.MstSDPId == null) {
        setBranchName(userProfileDatas[0]?.LocationName_en);
        setBranchProject([userProfileDatas[0]?.MstLocationId]);
        setSDP("");
      } else {
        setBranchName(userProfileDatas[0]?.LocationName_en);
        setBranchProject([userProfileDatas[0]?.MstLocationId]);
        setSDP([userProfileDatas[0]?.MstSDPId]);
      }
    }
    BranchProjectFetchData();
  }, [userProfileDatas ? userProfileDatas : undefined]);

  const GoButton = async () => {

    setIsLoading(true);
    const branchProjectValidate = branchProject ? "" : "Select Branch/Project";
    setBranchProjectError(branchProjectValidate);

    const fromYearValidate = year ? "" : "Select Year";
    setYearError(fromYearValidate)
    const sdpValidate = sdp ? "" : "Select SDP";
    setSDPError(sdpValidate);

    const areaValidate = area ? "" : "Select Area";
    setAreaError(areaValidate);
    setAreaError(areaValidate);
    const fromMonthValidate = fromDate ? "" : "Select Month";
    setFromDateError(fromMonthValidate);

    let branchProjectArray = Array.from(
      { length: branchProject.length },
      (v, i) => branchProject[i]
    );
    let branchProjectResult = branchProjectArray.join(",");

    let sdpArray = Array.from({ length: sdp.length }, (v, i) => sdp[i]);
    let sdpResult = sdpArray.join(",");

    let areaArray = Array.from({ length: area.length }, (v, i) => area[i]);
    let areaResult = areaArray.join(",");

    if (!branchProjectValidate && !sdpValidate && !areaValidate && !fromMonthValidate && !fromYearValidate) {
      const currentYear = new Date().getFullYear();

      // First day of the month
      const fromMonthDate = fromDate
        ? `${year}-${String(fromDate).padStart(2, "0")}-01`
        : "";

      // Last day of the month
      const toMonthDate = fromDate
        ? new Date(year, fromDate, 0).toISOString().split("T")[0]
        : "";
      const ReportData = [
        {
          mstBranchId: branchProjectResult,
          mstSDPId: sdpResult,
          mstAreaId: areaResult,
          fromDate: fromMonthDate,
          toDate: toMonthDate,
        },
      ];
      const response = await BindPostAPI(
        ReportData,
        "TXNServicesAPI/ReportCYPDHIS2SRH"
      );

      console.log("response", response.data.Table);
      setBindCYPDHIS2SRHData(response.data.Table);
      setShowTable(true);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    // const today = new Date();
    // const currentYear = today.getFullYear();
    // const automaticFromDate = `${currentYear}-01-01`;
    // setFromDate(automaticFromDate);

    // const formattedToDate = today.toISOString().split("T")[0];
    // setToDate(formattedToDate);
    getMonthDDValues();
  }, []);
  const getMonthDDValues = async () => {
    // Month Dropdown binding
    const response = await BindAPI("MasterDataAPI/BindMonth");
    const getTnxMonthId =
      response.data.Table && response.data.Table.length > 0
        ? response.data.Table.map((item) => ({
          value: item.TxnMonthId,
          label: item.MonthName,
        }))
        : [];
    setBindMonthDD(getTnxMonthId);
  };
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const yearsArray = Array.from(
      { length: 70 },
      (_, index) => currentYear - index
    );
    let yearDropdown = yearsArray.map((year) => ({
      label: year.toString(),
      value: year,
    }));
    setBindYearDD(yearDropdown);
  }, []);


  // const handleExport = () => {
  //   const dateRange = {
  //     fromDate: fromDate,
  //     toDate: toDate,
  //   };

  //   const selectedOptionsData = {
  //     branchProjectData:
  //       branchProjectNamesList.length > 0
  //         ? branchProjectNamesList.toString()
  //         : branchName,
  //     sdpData: sdpNamesList.toString(),
  //     areaData: areaNamesList.toString(),
  //   };

  //   exportData(
  //     cypDHIS2SRHHeader.map((column) => column.title),
  //     bindCYPDHIS2SRHData,
  //     dateRange,
  //     selectedOptionsData
  //   );
  // };


  const createdBy = sessionStorage.getItem("createdBy");
  const handleExport = async () => {

    try {



      const filterData = bindMonthDD.find(
        (item) => item.value === fromDate
      );


      const filterData1 = bindYearDD.find(
        (item) => item.value === year
      );

      const dateRange = {
        fromDate: filterData?.label || "",
        toDate: filterData1?.label || "",
      };

      const selectedOptionsData = {
        branchProjectData:
          branchProjectNamesList.length > 0
            ? branchProjectNamesList.toString()
            : branchName,
        sdpData: sdpNamesList.toString(),
        areaData: areaNamesList.toString(),
      };
      console.log(bindCYPDHIS2SRHData[0]);

      // Export Function
      await exportData(
        cypDHIS2SRHHeader.map((column) => column.title),
        bindCYPDHIS2SRHData,
        dateRange,
        selectedOptionsData
      );

      // ✅ Success Log
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: `CYP - SRH`,
          action: "Excel Export",
          status: "SUCCESS",
          tableName: null,
          description: `CYP - SRH Excel exported successfully for Month ${filterData?.label}, Year ${filterData1?.label}`,
        },
        "Log/IUDLog"
      );

      console.log("Excel export completed successfully");
    } catch (error) {
      console.error("Excel export failed:", error);

      // ❌ Failed Log
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: `CYP - SRH`,
          action: "Excel Export",
          status: "FAILED",
          tableName: null,
          description: `CYP - SRH Excel export failed - ${error?.message || "Unknown Error"
            }`,
        },
        "Log/IUDLog"
      );
    }
  };

  const formatNumber = (value) => {
    const num = Number(value || 0);
    return Number.isInteger(num) ? parseInt(num, 10) : num;
  };
  const displayValue = (value) => {
    const n = Number(value);

    return Number.isInteger(n)
      ? n.toString()
      : n.toString().replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, "");
  };
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return `${date.getDate().toString().padStart(2, "0")}-${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${date.getFullYear()}`;
  };

  const exportData = (columns, rows, dateRange, selectedDetails) => {
    const titleRow = [
      {
        v: "CYP - SRH",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    // Date range row with merged cells
    const dateRangeRow = [
      { v: "" },
      {
        v: "Month :",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
        },
      },
      {
        v: dateRange.fromDate,
        s: {
          alignment: { horizontal: "left" },
        },
      },
      {
        v: "Year :",
        s: {
          font: { bold: true },
          alignment: { horizontal: "left" },
        },
      },
      {
        v: dateRange.toDate,
        s: {
          alignment: { horizontal: "left" },
        },
      },
    ];

    // Branch information row with merged cells
    const branchRow = [
      { v: "" },

      {
        v: "Branch/Project:",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
        },
      },
      {
        v: selectedDetails.branchProjectData,
        s: {
          alignment: { horizontal: "left" },
          alignment: { wrapText: true }, // Enable text wrapping
        },
      },

      {
        v: "S.D.P.:",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
        },
      },
      {
        v: selectedDetails.sdpData,
        s: {
          alignment: { horizontal: "left" },
          alignment: { wrapText: true }, // Enable text wrapping
        },
      },

      {
        v: "Area:",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
        },
      },
      {
        v: selectedDetails.areaData,
        s: {
          alignment: { horizontal: "left" },
          alignment: { wrapText: true }, // Enable text wrapping
        },
      },
    ];

    // Add empty row for spacing
    const spacingRow = [{ v: "" }];

    const headerRow = [
      ...columns.map((column) => ({
        v: column,
        s: {
          fill: { fgColor: { rgb: "2D2D6E" } },
          font: { bold: true, color: { rgb: "FFFFFF" } },
          alignment: {
            horizontal: "center",
            vertical: "center",
            wrapText: true, // Enable text wrapping for headers
          },
        },
      })),
      {
        v: "Total",
        s: {
          fill: { fgColor: { rgb: "2D2D6E" } },
          font: { bold: true, color: { rgb: "FFFFFF" } },
          alignment: { horizontal: "right" },
        },
      },
    ];
    // Initialize column totals
    const columnTotals = {
      Age0to9: 0,
      Age10to14: 0,
      Age15to19: 0,
      Age20to24: 0,
      Age25to29: 0,
      Age30to34: 0,
      Age35to39: 0,
      Age40to44: 0,
      Age45to49: 0,
      Age50andAbove: 0,
    };

    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const baseStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      // Calculate row total for numeric fields
      const rowTotal =
        Number(rowData.Age0to9 || 0) +
        Number(rowData.Age10to14 || 0) +
        Number(rowData.Age15to19 || 0) +
        Number(rowData.Age20to24 || 0) +
        Number(rowData.Age25to29 || 0) +
        Number(rowData.Age30to34 || 0) +
        Number(rowData.Age35to39 || 0) +
        Number(rowData.Age40to44 || 0) +
        Number(rowData.Age45to49 || 0) +
        Number(rowData.Age50andAbove || 0);
      // Add to column totals
      columnTotals.Age0to9 += Number(rowData.Age0to9 || 0);
      columnTotals.Age10to14 += Number(rowData.Age10to14 || 0);
      columnTotals.Age15to19 += Number(rowData.Age15to19 || 0);
      columnTotals.Age20to24 += Number(rowData.Age20to24 || 0);
      columnTotals.Age25to29 += Number(rowData.Age25to29 || 0);
      columnTotals.Age30to34 += Number(rowData.Age30to34 || 0);
      columnTotals.Age35to39 += Number(rowData.Age35to39 || 0);
      columnTotals.Age40to44 += Number(rowData.Age40to44 || 0);
      columnTotals.Age45to49 += Number(rowData.Age45to49 || 0);
      columnTotals.Age50andAbove += Number(rowData.Age50andAbove || 0);

      return [
        {
          v: index + 1,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Branch,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.SDP_en,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.AreaName_en,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.CYP,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },

        {
          v: displayValue(rowData.Age0to9 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            // numFmt: "0",
            // numFmt: "0.00"
            numFmt: 'General'

          },
        },
        {
          v: displayValue(rowData.Age10to14 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            // numFmt: "0",
            // numFmt: "0.00"
            numFmt: '0.############;-0.############;0'

          },
        },
        {
          v: displayValue(rowData.Age15to19 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            // numFmt: "0",
            // numFmt: "0.00"
            numFmt: '0.############;-0.############;0'

          },
        },
        {
          v: displayValue(rowData.Age20to24 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            // numFmt: "0",
            // numFmt: "0.00"
            numFmt: '0.############;-0.############;0'

          },
        },
        {
          v: displayValue(rowData.Age25to29 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            // numFmt: "0",
            // numFmt: "0.00"
            numFmt: '0.############;-0.############;0'

          },
        },
        {
          v: displayValue(rowData.Age30to34 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            // numFmt: "0",
            // numFmt: "0.00"
            numFmt: '0.############;-0.############;0'

          },
        },
        {
          v: displayValue(rowData.Age35to39 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            // numFmt: "0",
            // numFmt: "0.00"
            numFmt: '0.############;-0.############;0'

          },
        },
        {
          v: displayValue(rowData.Age40to44 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            // numFmt: "0",
            // numFmt: "0.00"
            numFmt: '0.############;-0.############;0'

          },
        },
        {
          v: displayValue(rowData.Age45to49 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            // numFmt: "0",
            // numFmt: "0.00"
            numFmt: '0.############;-0.############;0'

          },
        },
        {
          v: displayValue(rowData.Age50andAbove || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            // numFmt: "0",
            // numFmt: "0.00"
            numFmt: '0.############;-0.############;0'

          },
        },

        // Row total
        {
          v: rowTotal,
          t: "n",
          s: {
            ...baseStyle,
            font: { bold: true },
            alignment: { horizontal: "right" },
            // numFmt: "0",
            // numFmt: "0.00"
            numFmt: '0.############;-0.############;0'

          },
        },
      ];
    });

    // Create totals row
    const totalsRowStyle = {
      font: { bold: true },
      fill: { fgColor: { rgb: "E0E0E0" } },
      alignment: { horizontal: "right" },
      // numFmt: "0",
      // numFmt: "0.00"
      numFmt: '0.############;-0.############;0'

    };

    const grandTotal = Object.values(columnTotals).reduce(
      (sum, val) => sum + val,
      0
    );

    const totalsRow = [
      { v: "", s: totalsRowStyle },
      {
        v: "Totals",
        s: { ...totalsRowStyle, alignment: { horizontal: "left" } },
      },
      { v: "", s: totalsRowStyle },
      { v: "", s: totalsRowStyle },
      { v: "", s: totalsRowStyle },
      { v: displayValue(columnTotals.Age0to9), t: "n", s: totalsRowStyle },
      { v: displayValue(columnTotals.Age10to14), t: "n", s: totalsRowStyle },
      { v: displayValue(columnTotals.Age15to19), t: "n", s: totalsRowStyle },
      { v: displayValue(columnTotals.Age20to24), t: "n", s: totalsRowStyle },
      { v: displayValue(columnTotals.Age25to29), t: "n", s: totalsRowStyle },
      { v: displayValue(columnTotals.Age30to34), t: "n", s: totalsRowStyle },
      { v: displayValue(columnTotals.Age35to39), t: "n", s: totalsRowStyle },
      { v: displayValue(columnTotals.Age40to44), t: "n", s: totalsRowStyle },
      { v: displayValue(columnTotals.Age45to49), t: "n", s: totalsRowStyle },
      { v: displayValue(columnTotals.Age50andAbove), t: "n", s: totalsRowStyle },

      // Grand total
      {
        v: displayValue(grandTotal),
        t: "n",
        s: {
          ...totalsRowStyle,
          font: { bold: true, color: { rgb: "2D2D6E" } },
        },
      },
    ];
    // Combine all rows

    const wsData = [
      titleRow,
      dateRangeRow,
      branchRow,
      spacingRow,
      headerRow,
      ...dataRows,
      totalsRow,
    ];
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    const range = XLSX.utils.decode_range(ws["!ref"]);

    console.log(ws["F6"]);


    for (let R = range.s.r; R <= range.e.r; R++) {
      for (let C = 5; C <= 15; C++) { // Numeric columns F to P
        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });

        if (ws[cellRef] && typeof ws[cellRef].v === "number") {
          ws[cellRef].z = "0.############";
        }
      }
    }
    // Set custom column widths
    ws["!cols"] = [
      { width: 8 }, // Index
      { width: 30 }, // Branch
      { width: 30 }, // IPC  No
      { width: 30 }, // Branch
      { width: 30 }, // IPC  No
      { width: 10 }, // Gender
      { width: 15 }, // Topics1
      { width: 15 }, // Topics2
      { width: 15 }, // Topics3
      { width: 20 }, // Topics4
      { width: 15 }, // Topics5
      { width: 10 }, // Topics6
      { width: 15 }, // Topics7
      { width: 15 }, // Topics8
      { width: 20 }, // Topics9
      { width: 20 }, // Topics10

      { width: 15 }, // Row Total
    ];

    // Set row heights for wrapped content
    ws["!rows"] = [
      { hpt: 25 }, // Title row height
      { hpt: 15 }, // Date range row height
      { hpt: 15 }, // Branch row height (taller for wrapped content)
      { hpt: 15 }, // Spacing row height
      { hpt: 15 }, // Header row height (taller for wrapped content)
      ...Array(rows.length).fill({ hpt: 15 }), // Data rows height
      { hpt: 15 }, // Totals row height
    ];

    // Apply borders and styles
    const applyStyles = (ws) => {
      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellRef]) continue;

          // Add borders to all cells
          ws[cellRef].s = {
            ...ws[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    // Create and save workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(wb, "CYP - SRH.xlsx");
  };

  const downloadPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a3",
    });
    const logoWidth = 30;
    const logoHeight = 14;
    doc.addImage(fpaiLogo, "JPEG", 10, 10, logoWidth, logoHeight);

    const headers = cypDHIS2SRHHeader.map((column) => column.title);

    const data = bindCYPDHIS2SRHData.map((rowData, index) => {
      return [
        index + 1,
        rowData.Branch,
        rowData.SDP_en,
        rowData.AreaName_en,
        rowData.CYP,
        rowData.Age0to9,
        rowData.Age10to14,
        rowData.Age15to19,
        rowData.Age20to24,
        rowData.Age25to29,
        rowData.Age30to34,
        rowData.Age35to39,
        rowData.Age40to44,
        rowData.Age45to49,
        rowData.Age50andAbove,
      ];
    });

    // Create the table with headers and data
    doc.autoTable({
      head: [headers],
      body: data,
      startY: 30,
      styles: {
        fontSize: 7, // Reduced font size
        lineColor: "black",
        lineWidth: 0.2,
        halign: "center", // Align text to center
        valign: "middle", // Align text vertically in the middle
        cellPadding: 2, // Add padding to cells
        overflow: "linebreak", // Allow text to wrap within cells
      },
      headStyles: {
        fillColor: "#2d2d6e",
        textColor: [255, 255, 255],
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240], // Light gray color for alternate rows
      },
      columnStyles: {
        0: { cellWidth: 10 }, // Index column
        1: { cellWidth: "auto" }, // Auto adjust width
        2: { cellWidth: "auto" }, // Auto adjust width
        3: { cellWidth: "auto" }, // Auto adjust width
        4: { cellWidth: "auto" }, // Auto adjust width
        5: { cellWidth: "auto" }, // Auto adjust width
        6: { cellWidth: "auto" }, // Auto adjust width
        7: { cellWidth: "auto" }, // Auto adjust width
        8: { cellWidth: "auto" }, // Auto adjust width
        9: { cellWidth: "auto" }, // Auto adjust width
        10: { cellWidth: "auto" }, // Auto adjust width
        11: { cellWidth: "auto" }, // Auto adjust width
        12: { cellWidth: "auto" }, // Auto adjust width
        13: { cellWidth: "auto" }, // Auto adjust width
        14: { cellWidth: "auto" }, // Auto adjust width
      },
    });

    doc.save("CYP - SRH.pdf");
  };
  const BranchProjectFetchData = async () => {
    try {
      const userProfileDatas = userProfileState.userProfile;
      const [profile] = userProfileDatas;
      const data = {
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
        languageCode: "en",
      };
      const locationResponse = await BindPostAPI([data], "LocationAPI/GetLocation");

      const locationData = locationResponse.data.Table.map((item) => ({
        value: item.MstLocationId,
        label: item.LocationName_en,
      }));

      setBindBranchProjectDD(locationData);
    } catch (error) { }
  };

  const sdpChange = (updatedOptions) => {
    setArea("");
    setShowTable(false);
    setSDP(updatedOptions);
    const SDPlabels = getSDPNames(updatedOptions);
    console.log("SDPlabels", SDPlabels);
    setSDPNamesList(SDPlabels);
  };

  const getSDPNames = (updatedOptions) => {
    const NameList = updatedOptions
      .map((option) => bindSDP?.find((item) => item.value === option)?.label)
      .filter(Boolean); // Remove undefined values if any

    return NameList;
  };

  const brangeChange = (updatedOptions) => {
    setSDP("");
    setShowTable(false);
    setBranchProject(updatedOptions);
    const branchProjectlabels = getBranchProjectsNames(updatedOptions);
    console.log("branchProjectlabels", branchProjectlabels);
    setBranchProjectNamesList(branchProjectlabels);
  };

  const getBranchProjectsNames = (updatedOptions) => {
    const NameList = updatedOptions
      .map(
        (option) =>
          bindBranchProjectDD?.find((item) => item.value === option)?.label
      )
      .filter(Boolean); // Remove undefined values if any

    return NameList;
  };

  const areaChange = (updatedOptions) => {
    setArea(updatedOptions);
    const arealabels = getAreaNames(updatedOptions);
    console.log("arealabels", arealabels);
    setAreaNamesList(arealabels);
    setShowTable(false);
  };

  const getAreaNames = (updatedOptions) => {
    const NameList = updatedOptions
      .map((option) => bindArea?.find((item) => item.value === option)?.label)
      .filter(Boolean); // Remove undefined values if any

    return NameList;
  };

  console.log("branchProject111", branchProject);
  return (
    <MainLayout pageName="4">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />

      <div>
        <div class="relative m-3 bg-white rounded-lg ">
          <div class="mt-3 py-4">
            <div className={mainTable.headerTitle}>
              <div className="my-2 mx-12 lg:mx-0">{`CYP - SRH`}</div>
            </div>
            <div className={mainTable.grid3}>
              {userProfileDatas[0]?.MstOrganizationId == 1 && (
                <div>
                  <MultiSelect
                    classStar="text-red-500"
                    label="Branch/Project"
                    filteredOptions={bindBranchProjectDD}
                    classFilterLabel="p-1 flex gap-1"
                    class="custom-class"
                    placeholder={
                      branchProject?.length > 0 ? "More Selected" : "Select..."
                    }
                    name="branchProject"
                    selectedOptions={branchProject}
                    classDiv="relative w-full inline-block"
                    onChange={brangeChange}
                    classLabel={mainTable.labelNoWrap}
                  />
                  {branchProjectError && (
                    <span className="text-red-500">{branchProjectError}</span>
                  )}
                </div>
              )}
              {(userProfileDatas[0]?.MstOrganizationId == 2 ||
                userProfileDatas[0]?.MstOrganizationId == 3) && (
                  <InputText
                    inputType="text"
                    title="Branch/Project"
                    classStar="text-red-500"
                    name="branchName"
                    disabled="true"
                    content={branchName}
                    controlFunc={(e) => setBranchName(e.target.value)}
                  />
                )}
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="SDP"
                  filteredOptions={bindSDP}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={sdp?.length > 0 ? "More Selected" : "Select..."}
                  name="sdp"
                  selectedOptions={sdp}
                  classDiv="relative w-full inline-block"
                  onChange={sdpChange}
                  classLabel={mainTable.labelNoWrap}
                />
                {sdpError && <span className="text-red-500">{sdpError}</span>}
              </div>

              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Area"
                  filteredOptions={bindArea}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={area?.length > 0 ? "More Selected" : "Select..."}
                  name="area"
                  selectedOptions={area}
                  classDiv="relative w-full inline-block"
                  onChange={areaChange}
                  classLabel={mainTable.labelNoWrap}
                />
                {areaError && <span className="text-red-500">{areaError}</span>}
              </div>
            </div>
            <div class={mainTable.grid3}>
              <AutoDropDown
                classStar="text-red-500"
                title="Month"
                options={bindMonthDD}
                placeholder="Select"
                name="fromDate"
                selectedOption={bindMonthDD.find(
                  (x) => x.value == fromDate
                )}
                Class="custom-class"
                tabIndex="1"
                controlFunc={(value, e) => {
                  setFromDate(value.value);
                }}
                controlFuncBlur={() => {
                  if (!fromDate) {
                    setFromDateError("Select From Month");
                  } else {
                    setFromDateError("");
                  }
                }}

                errorMessage={fromDateError}
              />
              <AutoDropDown
                classStar="text-red-500"
                title="Year"
                options={bindYearDD}
                placeholder="Select"
                name="year"
                selectedOption={bindYearDD.find(
                  (x) => x.value == year
                )}
                Class="custom-class"
                tabIndex="1"
                controlFunc={(value, e) => {
                  setYear(value.value);
                }}
                controlFuncBlur={() => {
                  if (!year) {
                    setYearError("Select Year");
                  } else {
                    setYearError("");
                  }
                }}

                errorMessage={yearError}
              />
              {/* <InputText
                inputType="date"
                title="From"
                name="fromDate"
                content={fromDate}
                controlFunc={(e) => {
                  setShowTable(false);
                  setFromDate(e.target.value);
                }}
              />
              <InputText
                inputType="date"
                title="To"
                name="toDate"
                content={toDate}
                controlFunc={(e) => {
                  setShowTable(false);
                  setToDate(e.target.value);
                }}
              /> */}
              <div class="flex justify-start items-center mt-6">
                <button
                  type="button"
                  onClick={() => GoButton()}
                  className={mainTable.addButton}
                >
                  GO
                </button>
              </div>
            </div>
          </div>
        </div>
        {showTable &&
          (bindCYPDHIS2SRHData.length > 0 ? (
            <div className=" ">
              <ReportGridPage
                title=""
                header={cypDHIS2SRHHeader}
                records={bindCYPDHIS2SRHData}
                handleExport={handleExport}
                handlePDF={downloadPDF}
              />
            </div>
          ) : (
            <div className="flex items-center justify-center">
              No record found
            </div>
          ))}
      </div>
    </MainLayout>
  );
};

export default CYPDHIS2SRH;
